/* eslint-disable no-debugger */
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HeaderComponent } from './shared/header/header.component';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { CommonModule } from '@angular/common';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'globalmtmwebview';
  isLoggedIn = false;
  userName = '';
  currentCountryCode= 'en-US'; // Default value
  showpage = false;
  showHeader = false;
  constructor(
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private activatedRoute: ActivatedRoute
  ) {}



  ngOnInit(): void {
    this.showHeader = this.shouldShowHeader();
    // Listen for login success events
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: any) => msg.eventType === 'msal:loginSuccess')
      )
      .subscribe(msg => {
        
        const idToken = (msg.payload as any).idToken;
        this.showpage = true;
       
        // Save the token to localStorage or sessionStorage
        localStorage.setItem('access_token', idToken);

        this.checkAccount();
        // Redirect to the route with countryCode after login
        // this.router.navigate([`/${this.currentCountryCode}/order-creation`]);
      });


     this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: any) => msg.eventType === 'msal:loginFailure'))
      .subscribe(() => {
        const isEmbedded = (() => { try { return window.self !== window.top; } catch { return true; } })();
        if (isEmbedded) {
          const parentOrigin = (() => {
            try {
              if (document.referrer) return new URL(document.referrer).origin;
            } catch {}
            return null;
          })();

          if (parentOrigin) {
            window.parent.postMessage({ type: 'REQUEST_LOGOUT' }, parentOrigin);
          }
          return; 
        }

        this.msalService.logoutRedirect({ postLogoutRedirectUri: '/' }).subscribe({
          next: () => { localStorage.setItem('access_token',''); this.router.navigate(['/']); },
          error: (err) => console.error('logout (redirect) error:', err),
        });
      });

    // Check if an account is already logged in on component initialization
    this.checkAccount();

    // Listen for route changes to update the countryCode
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap(route => route.paramMap)
      )
      .subscribe(params => {
        const code = params.get('countryCode');
        if (code) {
          this.currentCountryCode = code;
        }
      });
  }

  shouldShowHeader(): boolean {
    let route = this.activatedRoute.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
  
    const showHeader = route.snapshot.data['showHeader'] !== false;
    return showHeader;
  }
  

  // shouldShowHeader(): boolean {
  //   // Get the current URL path
  //   const currentUrl = this.router.url;

  //   // Extract the path before the hash fragment
  //   const urlBeforeHash = currentUrl.split('#')[0];

  //   // Split the URL into segments, removing any empty segments
  //   const urlSegments = urlBeforeHash.split('/').filter(segment => segment.length > 0);

  //   // Determine the path, excluding the country code if present
  //   const path = (urlSegments.length > 0 && this.isCountryCode(urlSegments[0]))
  //     ? `/${urlSegments.slice(1).join('/')}`
  //     : urlBeforeHash;

  //   // Further split the path to remove any query parameters
  //   const basePath = path.split('?')[0];

  //   // List of paths where the header should be hidden
  //   const pathsToHideHeader = [
  //     '/login',
  //     '/logout',
  //     '/reset',
  //     '/register',
  //     '/login-successfully',
  //     '/register-successfully',
  //     '/confirmation',
  //     '/edit-order-from-admin'
  //   ];

  //   // Check if the current path is in the list to hide the header
  //   const hideHeaderForPath = pathsToHideHeader.includes(basePath);

  //   // Check if the URL path contains "onmicrosoft.com" or "edit-order-from-admin"
  //   const hideHeaderForPathContent = currentUrl.includes('onmicrosoft.com') || currentUrl.includes('edit-order-from-admin');

  //   // Show the header only if neither condition is met
  //   return !hideHeaderForPath && !hideHeaderForPathContent;
  // }
  
  checkAccount(): void {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.showpage = true;
      this.isLoggedIn = true;
      this.userName = accounts[0].username; 
    } else {
      this.showpage = false;
      this.isLoggedIn = false;
    }
  }

  /**
   * Helper function to check if a segment is a valid countryCode.
   * Can be enhanced to validate specific formats like 'en-US', 'fr-CH', etc.
   */
  private isCountryCode(segment: string): boolean {
    // Simple regex to check the 'xx-XX' format
    return /^[a-z]{2}-[A-Z]{2}$/.test(segment);
  }
}
